<template>
  <div>
    <v-card-title>
      <h2><slot></slot></h2>
      <v-spacer/>
      <v-btn
        dark
        color="blue"
        round
        @click="$emit('new')">
        <v-icon
          dark
          left
        >
          {{ buttonIcon || 'mdi-script-outline'}}
        </v-icon>
        {{ buttonText || 'New Operation'}}
      </v-btn>
    </v-card-title>
  </div>
</template>

<script>
export default {
  name: 'BulkOpsHeader',
  props: ['buttonText', 'buttonIcon']
}
</script>
